/* @flow */
import * as React from 'react';

import invariant from 'invariant';
import ConfirmDialog from 'components/ConfirmDialog';
import QuickPromotion from 'entities/QuickPromotion';

class SisMergeExistingAccountsModal extends React.Component<{
  promotion: QuickPromotion,
  onConfirm: (data: Object) => void,
  onCancel: () => void,
  onRequestHide: () => any,
}> {
  handleConfirm = () => {
    this.props.onConfirm({});
    this.props.onRequestHide();
  };
  handleCancel = () => {
    this.props.onCancel();
    this.props.onRequestHide();
  };
  render() {
    const { promotion } = this.props;
    const secondaryAction = promotion.getSecondaryAction();
    invariant(secondaryAction, 'sis_merge_existing_accounts needs a secondary action');
    return (
      <ConfirmDialog
        eventScreenName="SisMergeExistingAccountsModal"
        className="SisMergeExistingAccountsModal"
        size="small"
        hideCloseButton
        hideOnTransition={false}
        hideOnBlur={false}
        title={promotion.getHeader()}
        subtext={promotion.getBody()}
        image={promotion.getImageUrl()}
        actionButtonText={promotion.getPrimaryAction().getLabel()}
        cancelButtonText={secondaryAction.getLabel()}
        onConfirm={this.handleConfirm}
        onCancel={this.handleCancel}
        onRequestHide={this.props.onRequestHide}
      />
    );
  }
}

export default SisMergeExistingAccountsModal;
